module.exports = __webpack_public_path__ + "img/availability.daa04cd3.svg";